import { Card, Grid, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { formatCount, getStatusOptions } from "../../utils/utils";

export default function Counts({ data, timeDomain, subject }) {
  const theme = useTheme();
  const statusOptions = getStatusOptions(theme);
  return (
    <>
      <Grid item xs={12} sm={4}>
        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.background.main,
            p: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            height: "100%",
          }}
        >
          <Stack direction="row" spacing={0.5} alignItems="center">
            {statusOptions?.["finished"]?.icon}
            <Typography variant="h5" sx={{ fontWeight: "bold", lineHeight: 1 }}>
              {subject} watched...
            </Typography>
          </Stack>
          <Typography
            variant="caption"
            sx={{
              lineHeight: 1.2,
              mt: 1,
              // textWrap: "balance",
            }}
          >
            {timeDomain
              ? `Based on all movies with a finish date in ${timeDomain}`
              : `Based on all movies currently marked as finished `}
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={3} sm={2}>
        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.secondary.main,
            py: 1,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column" spacing={0.5} alignItems="center">
            <Typography
              sx={{ fontSize: 36, fontWeight: "bold", lineHeight: 1 }}
            >
              {formatCount(data.counts.finished_count)}
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1 }}>
              {data.counts.finished_count === 1 ? "movie" : "movies"}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={3} sm={2}>
        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.secondary.main,
            py: 1,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column" spacing={0.5} alignItems="center">
            <Typography
              sx={{ fontSize: 36, fontWeight: "bold", lineHeight: 1 }}
            >
              {formatCount(Math.round(data.counts.finished_hours))}
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1 }}>
              {data.counts.finished_hours === 1 ? "hour" : "hours"}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={3} sm={2}>
        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.secondary.main,
            py: 1,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column" spacing={0.5} alignItems="center">
            <Typography
              sx={{ fontSize: 36, fontWeight: "bold", lineHeight: 1 }}
            >
              {formatCount(data.counts.finished_directors)}
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1 }}>
              {data.counts.finished_directors === 1 ? "director" : "directors"}
            </Typography>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={3} sm={2}>
        <Card
          elevation={0}
          sx={{
            backgroundColor: (theme) => theme.palette.secondary.main,
            py: 1,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column" spacing={0.5} alignItems="center">
            <Typography
              sx={{ fontSize: 36, fontWeight: "bold", lineHeight: 1 }}
            >
              {formatCount(data.counts.finished_languages)}
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1 }}>
              {data.counts.finished_languages === 1 ? "language" : "languages"}
            </Typography>
          </Stack>
        </Card>
      </Grid>
    </>
  );
}
